export default __webpack_public_path__ + "0b5a10bdde00583bc4fa24d0209a6380.png";